export default "__VITE_ASSET__ClZS$v_k__"